function o(e, ...t) {
  if (typeof e == "object" && e != null) {
    const n = [];
    for (const [i, c] of Object.entries(e))
      c && i && n.push(i);
    return n.join(" ");
  } else typeof e == "string" && t.unshift(e);
  return t.filter((n) => !!n).join(" ");
}
function l(e, ...t) {
  const n = o(...t);
  if (n)
    if (e.className) {
      if (typeof e.className == "function") {
        const i = e.className;
        return (...c) => o(i.call(e, ...c), n);
      }
    } else return n;
  else return e.className;
  return o(n, e.className);
}
export {
  o as c,
  l as g
};
